import { Link, Outlet, useNavigate } from 'react-router-dom';
import { Button } from '@nextui-org/react';
import { useAuth } from '../hooks/useAuth';
import { clearCrmDenied, crmDenied } from '../lib/crmAccess';
import { crmText as t } from '../lib/crmI18n';

// Directorio de agencias y sus apartados (solicitudes, preventa, lanzamiento…).
// Se editan con los permisos de siempre del backoffice; el CRM va aparte.
export default function AgencyReferenceLayout() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const denied = crmDenied(user?.uid);
  const recheck = () => { clearCrmDenied(user?.uid); navigate('/agencias'); };
  return <>
    {denied
      ? <aside role="status" className="mb-6 rounded-xl border border-warning-200 bg-warning-50 p-4 text-warning-700" aria-label={t.noAccessTitle}>
          <h2 className="font-semibold">{t.noAccessTitle}</h2>
          <p className="my-2 text-sm">{t.noAccessHelp}</p>
          <Button size="sm" variant="flat" onPress={recheck}>{t.recheckAccess}</Button>
        </aside>
      : <aside className="mb-6 rounded-xl border border-default-200 bg-content1 p-4" aria-label={t.referenceTitle}>
          <h2 className="font-semibold">{t.referenceTitle}</h2>
          <p className="my-2 text-sm text-default-500">{t.referenceHelp}</p>
          <Link className="text-primary underline" to="/agencias">{t.title}</Link>
        </aside>}
    <Outlet />
  </>;
}
